<template>
    <div class="app-container">

        <el-card class="search-form-card">

            <el-form ref="form" :inline="true" :model="form" class="search-form">
                <el-form-item label="拓扑名称:">
                    <el-input v-model="form.name" placeholder="请输入关键字" class="common-input"></el-input>
                    <el-button type="primary" @click='loadData'>搜索</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-card>

            <div slot="header">
               <!--  <router-link  :to="{ path:'/configurationUpdata', query: { callback: request } }" >

                </router-link> -->
                <el-button type="primary" v-w-role="'ITSM-0100'" @click="addTopologyEvent('add')">新增拓扑</el-button>
            </div>

            <el-table :data="tableData" style="width: 100%" stripe v-loading='loading'>

                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-for='item of pageSizes' :key='item' v-if="form.page_size===item">
                            {{form.page_index>1 ? scope.$index+1+(form.page_index-1)*item : scope.$index+1}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column label="拓扑名称" prop="company">
                    <template slot-scope='scope'>
                        <router-link  :to="{ path:'/relationship', query: {topology_id:scope.row.id,callback: request } }" >
                            <el-button type='text'>{{scope.row.name}}</el-button>
                        </router-link>

                    </template>
                </el-table-column>

                <el-table-column label="描述" prop="description"></el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <el-button type='text' @click="addTopologyEvent('edit',scope.row)">编辑</el-button>

                        <el-button v-w-role="'ITSM-0101'"  class="table-del-btn" @click.native.prevent="deleteRow(scope.$index, tableData, scope.row.id)" type="text">删除</el-button>
                        <!-- <router-link  :to="{ path:'/configurationDetail', query: { serialNumber: scope.row.id, callback:request } }">
                            <el-button type='text'>查看拓扑图</el-button>
                        </router-link> -->
                        <router-link  :to="{ path:'/topologicalGraph', query: { serialNumber:scope.row.id,type:'topologyMap' }}">
                            <el-button type='text'>查看拓扑图</el-button>
                        </router-link>


                    </template>
                </el-table-column>

            </el-table>

            <!-- 分页器 -->
            <!-- <el-pagination
             @size-change="handleSizeChange"
             @current-change="handleCurrentChange"
             :current-page="form.page_index"
             :page-sizes="[1,20, 30, 40]"
             :page-size="form.page_size"
             layout="total, sizes, prev, pager, next, jumper"
             :total="total">
            </el-pagination> -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.page_index"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="form.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
        </el-card>
        <el-dialog  :title="dialogTitle" :visible.sync="dialogFormVisible">
          <el-form ref="dialogForm" :model="dialogForm" label-width="80px">
            <el-form-item label="拓扑名称" >
              <el-input v-model="dialogForm.name" class="form-input"></el-input>
            </el-form-item>
            <el-form-item label="描述" >
                <el-input type="textarea" autosize class="form-input"
                    placeholder="请输入内容" v-model="dialogForm.description">
                </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="topologyMapSubmit">确 定</el-button>
          </div>
        </el-dialog>
    </div>
</template>

<script>
import services from '../configuration.services'
export default {

    data() {
        return {
            form: {
                page_index: 1,
                page_size: 10,
                name: ''
            },
            total: 0,
            pageSizes: [10, 20, 30, 40],
            tableData: [],
            loading: true,
            dialogFormVisible:false,
            flagSubmit:'add',
            dialogTitle:'新增拓扑',
            dialogForm:{
                name:'',
                description:''
            }
        }
    },

    computed:{
        dictionary(){
            return this.$store.state.dictionary;
        },
        cmdbStatus(){
            return this.dictionary.cmdb_status;
        },
    },

    mounted() {
        this.request()
    },

    methods: {
        //新增拓扑
        addTopologyEvent(flagstr,row){
            // console.log(row)
            this.dialogFormVisible = true
            this.flagSubmit = flagstr
            if(flagstr == 'edit'){
                this.dialogTitle = '编辑拓扑'
                this.dialogForm = {
                    name:row.name,
                    description:row.description,
                    topology_id:row.id
                }
            }else{
                this.dialogTitle = '新增拓扑'
                this.dialogForm={
                    name:'',
                    description:''
                }
            }
        },
        loadData(){
            this.form.page_index=1
            this.request()
        },
        // 请求数据
        request() {
            this.tableData = []
            this.loading = true
            services.topologyMapList(this.form)
                .then(res => {
                    this.tableData = res.list
                    this.total = +res.total
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },
        //拓扑新增
        topologyMapAdd(){
            services.topologyMapAdd(this.dialogForm)
            .then(res => {
                this.request()
            })
            .catch(err => this.$message.error(err.message))
            .finally(() => {
                this.dialogFormVisible = false
                this.dialogForm ={
                    name:'',
                    description:''
                }
            })
        },
        //拓扑编辑
        topologyMapEdit(){
            services.topologyMapEdit(this.dialogForm)
            .then(res => {
                this.request()
            })
            .catch(err => this.$message.error(err.message))
            .finally(() => {
                this.dialogFormVisible = false
                this.dialogForm ={
                    name:'',
                    topology_id:'',
                    description:''
                }
            })
        },
        topologyMapSubmit(){
            this.flagSubmit == 'edit' ? this.topologyMapEdit() : this.topologyMapAdd()
        },
        // 删除列表某一项
        deleteRow(index, rows, topology_id) {
            this.$confirm('此操作将永久删除该合同, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    services.topologyMapDel({topology_id: topology_id})
                        .then(res => {
                            this.$message.success('删除成功!')
                            rows.splice(index, 1);
                        }).catch(err => this.$message.error(err.message))
                }).catch(() => {
                    this.$message.info('已取消删除');
            });
        },

        // 更新分页器页数
        handleSizeChange(val){
            let pages = Math.ceil(this.total / val);
            this.form.page_size = val;
            if(this.form.page_index > pages ){
                this.form.page_index  = 1;
            };
            this.request();
        },

        // 更新分页器页码
        handleCurrentChange(val){
            this.form.page_index = val;
            this.request();
        },
    }
}
</script>

<style lang="scss" scoped>

</style>

